// Check if webapp is running in browser or PWA
export const isPWA = () => window.matchMedia('(display-mode: standalone)').matches;